import React from "react";
import styled from "styled-components";

//images
import HawkesLogo from "../assets/images/hawkes-logo.svg";
import HawkesSkull from "../assets/images/hawkes-skull-black.png";

const HeaderContainer = styled.header`
  padding-top: 30px;
  > img {
    width: 52px;
    height: 71px;
    object-fit: contain;
  }
  > h1 {
    padding: 10px;
    font-size: 0;
    > img {
      width: 179px;
      height: 88px;
      object-fit: contain;
    }
  }
  @media (max-width: 992px) {
    padding-top: 80px;
  }
`;

const HeadingDescription = styled.div`
  font-family: "Courier New";
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: center;
  padding: 0 45px;
  z-index: 100000;
  > a {
    color: black;
    &:hover {
      text-decoration: none;
    }
    > span {
      text-decoration: underline;
    }
  }
  @media (max-width: 992px) {
    line-height: 1.25;
  }
`;

const Header = () => (
  <HeaderContainer>
    <img src={HawkesSkull} alt="Hawkes Skull Logo" />
    <h1>
      <img src={HawkesLogo} alt="Hawkes Logo" />
    </h1>
    <HeadingDescription>
      Two Sessions, 18th July ONLY,{" "}
      <a href="https://www.copelandpark.com/">
        <span>Copeland Park</span>, <div />
        <span>133 Rye Lane, Peckham</span>, <span>London, SE15 4ST</span>
      </a>
    </HeadingDescription>
  </HeaderContainer>
);

export default Header;
